import { Theme } from '@emotion/react';
import { Box, SxProps } from '@mui/material';
import React from 'react';
import { styledPageSX } from '../styles/styles';

interface ContentWrapperProps {
  children: React.ReactNode;
  canEdit?: boolean;
  sx?: SxProps<Theme>;
}

/**
 * Common wrapper component used by FundOpportunityEOI and FullContentDiffViewer
 * to ensure consistent styling and layout
 */
const ContentWrapper: React.FC<ContentWrapperProps> = ({
  children,
  canEdit = false,
  sx = {} as SxProps<Theme>,
}) => {
  return (
    <Box
      display="flex"
      className="fundOppWrapper"
      sx={
        {
          ...styledPageSX,
          ...(canEdit ? { position: 'relative' } : {}),
          ...sx,
        } as SxProps<Theme>
      }
    >
      <Box
        flex="1"
        sx={{
          flexGrow: { xs: 1 },
          maxWidth: { xs: '100%' },
        }}
        className="fundOppWrapper2"
      >
        {children}
      </Box>
    </Box>
  );
};

export default ContentWrapper;
